import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=6c4a6fa2"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4a6fa2')) {
      api.createRecord('6c4a6fa2', component.options)
    } else {
      api.reload('6c4a6fa2', component.options)
    }
    module.hot.accept("./Cotizacion.vue?vue&type=template&id=6c4a6fa2", function () {
      api.rerender('6c4a6fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/cotizacion/Cotizacion.vue"
export default component.exports